import React from "react";
import { hydrate } from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import { IntlProviderWrapper } from "@app/translations/intl-provider.container";
import "@fontsource-variable/rubik";

import "./index.scss"; // This must be imported before the Routes
import "react-toastify/dist/ReactToastify.min.css";
import { Routes } from "@app/routes";
import { Providers } from "@app/providers"; // Must be imported after the styles

import { getStoreWithPreloadedState } from "../shared/redux/store";

// Create/use the store
// history MUST be passed here if you want syncing between server on initial route
const store = getStoreWithPreloadedState(window.__PRELOADED_STATE__);

hydrate(
  <ReduxProvider store={store}>
    <Router>
      <IntlProviderWrapper>
        <Providers />
        <React.Fragment>
          <Routes />
        </React.Fragment>
      </IntlProviderWrapper>
    </Router>
  </ReduxProvider>,
  document.getElementById("app")
);

if (process.env.NODE_ENV === "development") {
  if (module.hot) {
    module.hot.accept();
  }

  if (!window.store) {
    window.store = store;
  }
}
